import { ZxingBarcodeDetector } from './zxing-barcode-detector'
import { NativeBarcodeDetector } from './native-barcode-detector'
import { IBarcodeDetector, IBarcodeDetectorOptions } from './barcode-detector'

export class BarcodeDetectorFactory {
  static create(options?: IBarcodeDetectorOptions): IBarcodeDetector {
    if (options?.useNativeDetector !== false && 'BarcodeDetector' in window) {
      try {
        return new NativeBarcodeDetector(options)
      } catch (error) {
        console.warn('Native barcode detection failed to initialize, falling back to ZXing:', error)
      }
    }

    return new ZxingBarcodeDetector(options)
  }
}
